import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Grid, Container, Typography, FormControl, InputLabel, FormHelperText, Stack, TextField, InputAdornment, Tabs, Tab, CircularProgress, Select, MenuItem } from '@mui/material';
import { LocalizationProvider, DateCalendar, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs/AdapterDayjs';
// Icons
import Icon from '@mdi/react';
import { mdiCurrencyUsd, mdiPound } from '@mdi/js';
// components
import moment from 'moment/moment';
import { format } from 'date-fns';
import { useState } from 'react';
import axios from 'axios';
import ApiHistorico from '../services/ApiHistorico';
import Iconify from '../components/iconify';
// sections
import {
    AppTasks,
    AppNewsUpdate,
    AppOrderTimeline,
    AppCurrentVisits,
    AppWebsiteVisits,
    AppTrafficBySite,
    AppWidgetSummary,
    AppCurrentSubject,
    AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardAppHistory() {
    const theme = useTheme();
    const [displayLoad, setDisplayLoad] = useState(false);
    const [inconsistencias, setInconsistencias] = useState([]);
    const [value, setValue] = useState(0);
    const [colores, setColores] = useState(['primary', 'warning']);
    const obtenerHistorico = (e) => {
        setDisplayLoad(true)
        moment.locale('es');
        const date = new Date(e);
        const newDate = moment(date.toDateString()).format('DD/MM/YYYY');
        axios.get(`${ApiHistorico}?fecha=${newDate}`)
            .then((dataResult) => {
                console.log(dataResult);
                setInconsistencias(dataResult.data);
                setDisplayLoad(false);
            })
            .catch(console.log);
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <Helmet>
                <title> Tablero Inconsistencias | Histórico </title>
            </Helmet>

            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 5 }}>
                    Categoría: Histórico
                </Typography>
                <Grid container>
                    <Grid item style={{ boxShadow: 'rgba(0, 0, 0, 0.125) 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 1px 3px' }}>
                        <FormControl>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={3}>
                                    <DateCalendar
                                        label="Seleccione una Fecha"
                                        onChange={(e) => {
                                            obtenerHistorico(e);
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item container xs={6} spacing={2}>
                        <Grid item />
                        <Grid item xs>
                            <FormControl>
                                <InputLabel id="inconsistencia-label">Inconsistencia</InputLabel>
                                <Select labelId="inconsistencia-label" id="inconsistencia" label="Inconsistencia">
                                    {
                                        inconsistencias.map((itemInconsistencia, index) => (
                                            itemInconsistencia !== '' ?
                                                <MenuItem style={{ textTransform: 'capitalize' }} key={index} value={itemInconsistencia.descrip}>{itemInconsistencia.descrip}</MenuItem>
                                                : null
                                        ))
                                    }
                                </Select>
                                <FormHelperText>Seleccione la Inconsistencia</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <FormControl>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DatePicker />
                                    </Stack>
                                </LocalizationProvider>
                                <FormHelperText>Seleccione la Fecha Inicial</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs>
                            <FormControl>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DatePicker />
                                    </Stack>
                                </LocalizationProvider>
                                <FormHelperText>Seleccione la Fecha Final</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* <Grid item container xs={8} spacing={2}>
                        <Grid item />
                        <Grid item>
                            
                        </Grid>
                        <Grid item>
                            
                        </Grid>
                        <Grid item>
                            
                        </Grid>
                    </Grid> */}
                </Grid>
                <br />
                <br />
                <Box>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="INCONSISTENCIAS" />
                        {/* <Tab label="GRÁFICO 1" />
						<Tab label="GRÁFICO 2" /> */}
                    </Tabs>
                </Box>
                <Box>
                    <br />
                    {
                        displayLoad ?
                            <CircularProgress style={{ display: displayLoad === true ? 'block' : 'none' }} />
                            :
                            value === 0 && (
                                <Grid container spacing={3}>
                                    {
                                        inconsistencias.map((itemInconsistencias, index) => {
                                            return (
                                                itemInconsistencias.categoria === 'HISTORICO' ?
                                                    <Grid key={index} item xs={12} sm={6} md={3}>
                                                        <AppWidgetSummary
                                                            title={itemInconsistencias.descrip}
                                                            total={itemInconsistencias.valor}
                                                            icon={'ant-design:download'}
                                                            categoria={itemInconsistencias.categoria}
                                                            downloadurl={itemInconsistencias.descarga}
                                                            color={index % 2 === 0 ? colores[0] : colores[1]}
                                                        />
                                                    </Grid>
                                                    : null
                                            );
                                        })
                                    }
                                </Grid>
                            )
                    }
                </Box>
                {/* <Box>
                    <Grid item xs={12} md={6} lg={8}>
                        <AppWebsiteVisits
                            title="Website Visits"
                            subheader="(+43%) than last year"
                            chartLabels={[
                                '01/01/2003',
                                '02/01/2003',
                                '03/01/2003',
                                '04/01/2003',
                                '05/01/2003',
                                '06/01/2003',
                                '07/01/2003',
                                '08/01/2003',
                                '09/01/2003',
                                '10/01/2003',
                                '11/01/2003',
                            ]}
                            chartData={[
                                {
                                    name: 'Team A',
                                    type: 'column',
                                    fill: 'solid',
                                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                                },
                                {
                                    name: 'Team B',
                                    type: 'area',
                                    fill: 'gradient',
                                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                                },
                                {
                                    name: 'Team C',
                                    type: 'line',
                                    fill: 'solid',
                                    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                                },
                            ]}
                        />
                    </Grid>
                </Box> */}
                {/* <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Weekly Sales" total={714000} icon={'ant-design:android-filled'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="New Users" total={1352831} color="info" icon={'ant-design:apple-filled'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Item Orders" total={1723315} color="warning" icon={'ant-design:windows-filled'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <AppWidgetSummary title="Bug Reports" total={234} color="error" icon={'ant-design:bug-filled'} />
                    </Grid>
                    <Grid item xs={12} md={6} lg={8}>
                        <AppWebsiteVisits
                            title="Website Visits"
                            subheader="(+43%) than last year"
                            chartLabels={[
                                '01/01/2003',
                                '02/01/2003',
                                '03/01/2003',
                                '04/01/2003',
                                '05/01/2003',
                                '06/01/2003',
                                '07/01/2003',
                                '08/01/2003',
                                '09/01/2003',
                                '10/01/2003',
                                '11/01/2003',
                            ]}
                            chartData={[
                                {
                                    name: 'Team A',
                                    type: 'column',
                                    fill: 'solid',
                                    data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                                },
                                {
                                    name: 'Team B',
                                    type: 'area',
                                    fill: 'gradient',
                                    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                                },
                                {
                                    name: 'Team C',
                                    type: 'line',
                                    fill: 'solid',
                                    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                                },
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <AppCurrentVisits
                            title="Current Visits"
                            chartData={[
                                { label: 'America', value: 4344 },
                                { label: 'Asia', value: 5435 },
                                { label: 'Europe', value: 1443 },
                                { label: 'Africa', value: 4443 },
                            ]}
                            chartColors={[
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                theme.palette.warning.main,
                                theme.palette.error.main,
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={8}>
                        <AppConversionRates
                            title="Conversion Rates"
                            subheader="(+43%) than last year"
                            chartData={[
                                { label: 'Italy', value: 400 },
                                { label: 'Japan', value: 430 },
                                { label: 'China', value: 448 },
                                { label: 'Canada', value: 470 },
                                { label: 'France', value: 540 },
                                { label: 'Germany', value: 580 },
                                { label: 'South Korea', value: 690 },
                                { label: 'Netherlands', value: 1100 },
                                { label: 'United States', value: 1200 },
                                { label: 'United Kingdom', value: 1380 },
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <AppCurrentSubject
                            title="Current Subject"
                            chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
                            chartData={[
                                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
                            ]}
                            chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={8}>
                        <AppNewsUpdate
                            title="News Update"
                            list={[...Array(5)].map((_, index) => ({
                                id: faker.datatype.uuid(),
                                title: faker.name.jobTitle(),
                                description: faker.name.jobTitle(),
                                image: `/assets/images/covers/cover_${index + 1}.jpg`,
                                postedAt: faker.date.recent(),
                            }))}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <AppOrderTimeline
                            title="Order Timeline"
                            list={[...Array(5)].map((_, index) => ({
                                id: faker.datatype.uuid(),
                                title: [
                                    '1983, orders, $4220',
                                    '12 Invoices have been paid',
                                    'Order #37745 from September',
                                    'New order placed #XF-2356',
                                    'New order placed #XF-2346',
                                ][index],
                                type: `order${index + 1}`,
                                time: faker.date.past(),
                            }))}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <AppTrafficBySite
                            title="Traffic by Site"
                            list={[
                                {
                                    name: 'FaceBook',
                                    value: 323234,
                                    icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} />,
                                },
                                {
                                    name: 'Google',
                                    value: 341212,
                                    icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} />,
                                },
                                {
                                    name: 'Linkedin',
                                    value: 411213,
                                    icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} />,
                                },
                                {
                                    name: 'Twitter',
                                    value: 443232,
                                    icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} />,
                                },
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} lg={8}>
                        <AppTasks
                            title="Tasks"
                            list={[
                                { id: '1', label: 'Create FireStone Logo' },
                                { id: '2', label: 'Add SCSS and JS files if required' },
                                { id: '3', label: 'Stakeholder Meeting' },
                                { id: '4', label: 'Scoping & Estimations' },
                                { id: '5', label: 'Sprint Showcase' },
                            ]}
                        />
                    </Grid>
                </Grid> */}
            </Container>
        </>
    );
}
